export const UI_TOGGLE_PLAYER_MODAL = 'UI_TOGGLE_PLAYER_MODAL'
export function togglePlayerModal() {
    return {
        type: UI_TOGGLE_PLAYER_MODAL,
    }
}
